'use client';

import React, { useState } from "react";
import ADD from "@/assets/images/Add.svg";
import SUBTRACT from "@/assets/images/Subtract.svg";
import { Image } from '@/lib/target';
import { Link } from '@/lib/target';
import { usePathname } from "@/lib/target";

const StandingHeader = ({ leagues, type, classes }) => {

  const pathname = usePathname();
  const pathArray = pathname.split('/').filter((path) => path);
  const path = pathArray[pathArray.length - 1];

  const [isOpen, setIsOpen] = useState(false);
  

  const activeClass = `bg-button-blue-bet @lg:bg-transparent text-white @lg:text-button-blue-bet px-1 @lg:p-0 py-1 rounded`;
  const activeMdClass = `font-semibold relative @lg:before:absolute before:left-0 before:h-0.5 before:-bottom-1 before:w-full before:bg-button-blue-bet dark:before:bg-white z-1`;
  return (
    <div className={`bg-button-blue-bet dark:bg-dark-slate  w-full rounded-lg my-2 ${classes}`}>
      <div className={`relative text-xs border-b border-transparent z-2 bg-white dark:bg-dark-slate rounded justify-between overflow-hidden transition-all duration-500 ${isOpen ? 'shadow h-28 w-full !overflow-y-scroll @lg:!overflow-hidden' : 'h-6 @lg:h-8 w-5/6'}`}>
        <ul id="tabs" className="absolute h-28 flex flex-wrap pr-8 pl-2 w-full @xl:w-[980px]">
          {leagues.slice(0, 20).map((item, index) => (
            <li key={index} className="flex items-center justify-center h-6 @lg:h-8 text-xxs @lg:text-xs">
              <Link  
                href={`/${type}/${item.slug}`}
                key={item.id}
                className={`cursor-pointer text-gray-800 dark:text-white ${ path === item.slug ? `${activeMdClass} ${activeClass}` : '' }`}
              >
                {item.name || item.vn}
              </Link>
              <div className={`mx-1.5 @lg:mx-3 pb-1 h-4 border-solid border-l`}></div>
            </li>
          ))}
        </ul>
        <div className="absolute w-6 h-6 @lg:w-8 @lg:h-8 top-0 right-0 bg-white flex items-center justify-center">
          <button className="" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <Image alt="Net88" src={SUBTRACT}/> : <Image alt="Net88" src={ADD} />}
          </button>
      </div>
      </div>
    </div>
  );
};

export default React.memo(StandingHeader);